import React from "react";
import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, lede, rule = true }) {
  return (
    <section className="max-w-8xl mx-auto px-5 md:px-10 lg:px-14 pt-10 md:pt-16 pb-10 md:pb-14">
      {eyebrow && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="eyebrow mb-5"
        >
          {eyebrow}
        </motion.div>
      )}
      <motion.h1
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tightish text-ink leading-[1.05] max-w-5xl"
      >
        {title}
      </motion.h1>
      {lede && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-xl md:text-2xl text-ink-soft mt-6 max-w-3xl leading-relaxed"
        >
          {lede}
        </motion.p>
      )}
      {rule && <div className="rule-gold mt-12" />}
    </section>
  );
}
